import { createContext, useContext } from 'react';

const LenisContext = createContext(null);

export const useLenis = () => useContext(LenisContext);
export default LenisContext;
